import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from "@material-ui/core/styles";

const CustomToolbar = (p) => {
    const classes = p.classes;
    return (
        <React.Fragment>
            {p.state.itensAlterados.length>0 &&
                <>
                    <Tooltip title={'Cancelar mudanças'}>
                        <IconButton className={classes.iconButton} onClick={p.handleDialogCancelarOpen}>
                            <CancelIcon className={classes.deleteIcon} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Salvar mudanças'}>
                        <IconButton className={classes.iconButton} onClick={p.handleDialogConfirmOpen}>
                            <CheckIcon className={classes.deleteIcon} />
                        </IconButton>
                    </Tooltip>
                </>
            }
        </React.Fragment>
    );

};

export default withStyles((theme)=>({
    iconButton: {
        '&:hover': {
            color: theme.palette.primary.main
        },
    }
}),{ name: 'CustomToolbar'},)(CustomToolbar);